module.exports = __webpack_public_path__ + "static/media/ar-camera.36ed3b73.png";